export const appRoutes = {
  auth: {
    login: '/login',
    forgotPassword: '/recuperar-senha',
    resetPassword: '/reset-password',
  },
  dashboard: '/dashboard',
  ajuda: '/ajuda',
  fazendas: {
    list: '/fazendas',
    view: (id: string) => `/fazendas/${id}`,
    edit: (id: string) => `/fazendas/${id}/editar`,
  },
  areas: {
    list: '/areas',
    view: (id: string) => `/areas/${id}`,
    edit: (id: string) => `/areas/${id}/editar`,
  },
  ingredientes: {
    list: '/ingredientes',
    view: (id: string) => `/ingredientes/${id}`,
    edit: (id: string) => `/ingredientes/${id}/editar`,
  },
  formulas: {
    list: '/formulas',
    view: (id: string) => `/formulas/${id}`,
    edit: (id: string) => `/formulas/${id}/editar`,
  },
  programas: {
    list: '/programas',
    view: (id: string) => `/programas/${id}`,
    edit: (id: string) => `/programas/${id}/editar`,
  },
  curvasDeGanho: {
    list: '/curvas-de-ganho',
    view: (id: string) => `/curvas-de-ganho/${id}`,
    edit: (id: string) => `/curvas-de-ganho/${id}/editar`,
  },
  lotes: {
    list: '/lotes',
    view: (id: string) => `/lotes/${id}`,
    edit: (id: string) => `/lotes/${id}/editar`,
  },
  animais: {
    list: '/animais',
  },
  movimentacoes: {
    list: '/movimentacoes',
  },
  contratos: {
    list: '/contratos',
    view: (id: string) => `/contratos/${id}`,
  },
  manejo: {
    list: '/manejo',
  },
  pasto: '/pasto',
  nutricao: {
    list: '/nutricao',
    view: (date: string) => `/nutricao/${date}`,
    ajusteDiario: (date: string) => `/nutricao/${date}/ajuste-diario`,
  },
  cocho: {
    list: '/cocho',
    area: (areaId: string) => `/cocho/areas/${areaId}`,
    areaAt: (areaId: string, date: string) => `/cocho/areas/${areaId}?date=${date}`,
  },
  producao: {
    list: '/producao',
    nova: '/producao/nova',
    view: (id: string) => `/producao/${id}`,
  },
  /** Só redireciona para `financeiro.estoque` (links antigos). */
  estoque: '/estoque',
  financas: {
    list: '/financas',
    view: (id: string) => `/financas/${id}`,
  },
  financasDetalhe: '/financas-detalhe',
  // Financeiro gerencial (área própria; plano UX do Financeiro §3).
  financeiro: {
    root: '/financeiro',
    resumo: '/financeiro/visao-geral',
    caixa: '/financeiro/contas/caixa',
    aPagar: '/financeiro/contas/pagar',
    aReceber: '/financeiro/contas/receber',
    compras: '/financeiro/contas/compras',
    notasRecebidas: '/financeiro/contas/notas-recebidas',
    notaRecebida: (id: string) => `/financeiro/contas/notas-recebidas/${id}`,
    /** Detalhe da compra em página; `?acao=receber|gerar-conta|editar`. */
    compraDetalhe: (id: string) => `/financeiro/contas/compras/${id}`,
    /** Itens de compra sem estoque (E3B: peças, materiais, serviços). */
    itensCompra: '/financeiro/contas/compras/itens',
    itemCompraDetalhe: (id: string) => `/financeiro/contas/compras/itens/${id}`,
    estoque: '/financeiro/estoque',
    contasFinanceiras: '/financeiro/cadastros/contas',
    categorias: '/financeiro/cadastros/categorias',
    centros: '/financeiro/custos/centros',
    subcentros: '/financeiro/custos/subcentros',
    /** Projetos (E5B): orçado, comprometido e pago por iniciativa. */
    projetos: '/financeiro/custos/projetos',
    projetoDetalhe: (id: string) => `/financeiro/custos/projetos/${id}`,
    custeio: '/financeiro/custos/custeio',
    dre: '/financeiro/resultados/dre',
    custosDoPeriodo: '/financeiro/resultados/custos-do-periodo',
  },
  transferencias: {
    list: '/transferencias',
    receber: (id: string) => `/transferencias/${id}/receber`,
  },
  // Cadastro único no Financeiro › Cadastros; `/fornecedores` e
  // `/compradores` antigos só redirecionam.
  fornecedores: {
    list: '/financeiro/cadastros/fornecedores',
    view: (id: string) => `/financeiro/cadastros/fornecedores/${id}`,
    edit: (id: string) => `/financeiro/cadastros/fornecedores/${id}/editar`,
  },
  compradores: {
    list: '/financeiro/cadastros/compradores',
    view: (id: string) => `/financeiro/cadastros/compradores/${id}`,
    edit: (id: string) => `/financeiro/cadastros/compradores/${id}/editar`,
  },
  usuarios: {
    list: '/usuarios',
    view: (id: string) => `/usuarios/${id}`,
    edit: (id: string) => `/usuarios/${id}/editar`,
  },
  licencas: '/licencas',
  relatorios: '/relatorios',
  avaliacoes: {
    list: '/avaliacoes',
    edit: (id: string) => `/avaliacoes/${id}/editar`,
  },
  operacao: {
    list: '/operacao',
  },
  automacao: {
    list: '/automacao',
    // Rota técnica, separada do cadastro do gestor (seção 22 do plano):
    // perfil de equipamento é decisão de quem homologa, não de quem planeja.
    perfisTecnicos: '/automacao/perfis-tecnicos',
  },
  sanitario: {
    list: '/sanitario',
    productView: (id: string) => `/sanitario/produtos/${id}`,
    productEdit: (id: string) => `/sanitario/produtos/${id}/editar`,
  },
} as const;
